import { fetch } from "../network";
import { userConfigs } from "./constants";
import { UserSerializer } from "./UserSerializer";

const _ = userConfigs;
const userSerializer = UserSerializer();

export function UserController() {
  /**
   * sign-up an account with a specific role
   * @param body
   * @param role
   * @returns {Promise<unknown>}
   */
  const createUser = (body, role = "broker") => {
    const serializedBody = userSerializer.createUserSerializer(body);
    const endpoint = `${_.createUser.endpoint}/${role}`;
    return new Promise((resolve, reject) => {
      fetch(_.createUser.method, endpoint, serializedBody)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  /**
   * sign-in
   * @param body
   * @returns {Promise<unknown>}
   */
  const createSession = (body) => {
    return new Promise((resolve, reject) => {
      fetch(_.createSession.method, _.createSession.endpoint, {
        email: body.email,
        password: body.password,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  /**
   * sign-out
   */
  const deleteSession = () => {
    return new Promise((resolve, reject) => {
      fetch(_.deleteSession.method, _.deleteSession.endpoint)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  /**
   * get profile
   * @returns {Promise<unknown>}
   */
  const getCurrentUserInfo = () => {
    return new Promise((resolve, reject) => {
      fetch(_.getCurrentUserInfo.method, _.getCurrentUserInfo.endpoint)
        .then((response) =>
          resolve(userSerializer.getCurrentUserInfoDeserializer(response.data))
        )
        .catch((error) => reject(error.response));
    });
  };

  /**
   * edit profile
   * @param body
   * @returns {Promise<unknown>}
   */
  const updateCurrentUserInfo = (body) => {
    const serializedBody = userSerializer.updateCurrentUserInfoSerializer(body);
    return new Promise((resolve, reject) => {
      fetch(
        _.updateCurrentUserInfo.method,
        _.updateCurrentUserInfo.endpoint,
        serializedBody
      )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  const updatePassword = (body) => {
    const serializedBody = userSerializer.updatePassword(body);
    return new Promise((resolve, reject) => {
      fetch(_.updatePassword.method, _.updatePassword.endpoint, serializedBody)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  /**
   * request a reset password email
   * @param body
   * @returns {Promise<unknown>}
   */
  const requestPasswordReset = (body) => {
    return new Promise((resolve, reject) => {
      fetch(
        _.requestPasswordReset.method,
        _.requestPasswordReset.endpoint,
        body
      )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  const resetPassword = (body) => {
    return new Promise((resolve, reject) => {
      fetch(_.resetPassword.method, _.resetPassword.endpoint, body)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  const verifyEmail = (token) => {
    return new Promise((resolve, reject) => {
      const endpoint = _.emailVerification.endpoint.replace("$token", token);
      fetch(_.emailVerification.method, endpoint, {})
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response));
    });
  };

  return Object.freeze({
    createUser,
    createSession,
    deleteSession,
    getCurrentUserInfo,
    updateCurrentUserInfo,
    updatePassword,
    resetPassword,
    requestPasswordReset,
    verifyEmail,
  });
}
